import { render, staticRenderFns } from "./dialog-name-detail.vue?vue&type=template&id=9975b76c&scoped=true"
import script from "./dialog-name-detail.vue?vue&type=script&lang=js"
export * from "./dialog-name-detail.vue?vue&type=script&lang=js"
import style0 from "./dialog-name-detail.vue?vue&type=style&index=0&id=9975b76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9975b76c",
  null
  
)

export default component.exports